import { render, staticRenderFns } from "./StoreSocialMedia.vue?vue&type=template&id=dcdf880a"
import script from "./StoreSocialMedia.vue?vue&type=script&lang=js"
export * from "./StoreSocialMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports